module.exports = __webpack_public_path__ + "static/img/medical-zhuanli.b1016bd6.png";